import { RouteProp, useRoute } from "@react-navigation/native";
import { StyleSheet, View } from "react-native";
import CustomText from "../components/common/general/CustomText/CustomText";
import LTILayout from "../layouts/LTILayout";
import type { RootStackParamList } from "../navigation/navigation.types";

/**
 * Stub view for LTI ILE student runtime (A5).
 * Students land here after an LTI resource-link launch to interact with the ILE.
 */
function LTIILEView() {
  const route = useRoute<RouteProp<RootStackParamList, "LTIILE">>();
  const { activityId } = route.params;

  return (
    <LTILayout>
      <View style={styles.container}>
        <CustomText text="Interactive Learning Environment" size="l" weight="bold" useTranslationText={false} />
        <CustomText text={`Activity: ${activityId}`} size="s" useTranslationText={false} style={styles.meta} />
        <CustomText
          text="This view will be implemented in task A5."
          size="m"
          useTranslationText={false}
          style={styles.placeholder}
        />
      </View>
    </LTILayout>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 24,
    alignItems: "center",
    justifyContent: "center",
    gap: 12,
  },
  meta: {
    color: "#6B7280",
  },
  placeholder: {
    color: "#9CA3AF",
    marginTop: 8,
  },
});

export default LTIILEView;
